<template>
  <div class="roomList">
    <div class="list-box">
      <myScroll style="width:100%;height:100%">
        <el-table :data="list"
                  :header-cell-style="{background:'#efeff5',padding: '6px 0'}"
                  :border="false"
                  ref="tableLayer"
                  @row-click="handleRowClick"
                  @selection-change="changeSelect">
          <el-table-column type="selection"
                           header-align="center"
                           width="45">
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <el-input size="mini"
                        @change="searchRoom"
                        v-model="search"
                        clearable
                        prefix-icon="el-icon-search"
                        :placeholder="$t('model.Search')"
                        class="search"></el-input>
            </template>
            <template slot-scope="scope">
              <div class="name">{{scope.row.name}}</div>
              <span>{{scope.row.area}}</span>,
              <span> {{scope.row.len}}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="buttonDiv">
          <el-tooltip :content="tooltipContent"
                      placement="bottom">
            <div v-if="!disabled">
              <el-dropdown @command="openAddTask"
                           trigger="click"
                           v-has="'Add Task'">
                <span class="el-dropdown-link">
                  <el-button slot="reference"
                             type="primary"
                             circle
                             icon="el-icon-plus">
                  </el-button>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">{{$t('model.Task')}}</el-dropdown-item>
                  <el-dropdown-item command="1">{{$t('model.ProductInstallation')}}</el-dropdown-item>
                  <el-dropdown-item command="2">{{$t('model.Moisture')}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div v-else>
              <span class="el-dropdown-link">
                <el-button slot="reference"
                           type="primary"
                           :disabled="disabled"
                           v-has="'Add Task'"
                           circle
                           icon="el-icon-plus">
                </el-button>
              </span>
            </div>
          </el-tooltip>
        </div>
      </myScroll>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data () {
    return {
      list: [],
      search: ''
    }
  },
  computed: {
    tooltipContent () {
      return this.disabled ? this.$t('model.PleaseSelectRoom') : this.$t('model.Addmultipletasksfromrooms')
    },
    addTaskDialogShow () {
      return this.$store.state.diag.params.addTaskDialog.showDialog
    },
    roomList () {
      return this.$store.state.diag.data.roomList
    },
    disabled () {
      if (this.$store.state.diag.data.addRoomList && this.$store.state.diag.data.addRoomList.length > 0) {
        return false
      } else {
        return true
      }
    }
  },
  created () {
  },
  mounted () {
    this.list = _.cloneDeep(this.roomList)
  },
  watch: {
    addTaskDialogShow (to, from) {
      if (!to) {
        this.$refs.tableLayer.clearSelection()
      }
    },
    roomList (to, from) {
      this.list = _.cloneDeep(to)
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      this.$refs.tableLayer.toggleRowSelection(row)
    },
    openAddTask (command) {
      this.$store.commit('diag/setAddTaskType', command)
      this.$store.commit('diag/openAddTaskDialog', true)
    },
    changeSelect (val) {
      this.$store.commit('diag/setAddRoomList', val)
    },
    searchRoom () {
      if (this.search) {
        let list = _.cloneDeep(this.roomList)
        let string = RegExp(this.search, 'i')
        this.list = []
        for (let i of list) {
          if (i.name.search(string) >= 0) {
            this.list.push(i)
          }
        }
      } else {
        this.list = this.roomList
      }
    }
  },
  components: {
  }
}
</script>
<style scoped lang="scss">
.roomList {
  height: 100%;
  height: 100%;
  .header {
    height: 38px;
    overflow: hidden;
    background-color: #fff;
    padding: 0 10px;
    line-height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dcdfe6;
    .title {
      flex-grow: 15;
    }
    .el-dropdown {
      line-height: 36px;
      width: 35px;
    }
    span {
      flex-grow: 1;
      line-height: 36px;
    }
    .el-button {
      flex-grow: 1;
    }
    .filter {
      font-size: 18px;
      color: #4193f6;
    }
    .add {
      font-size: 22px;
      color: #4193f6;
    }
  }
  .list-box {
    width: 100%;
    height: calc(100% - 2px);
    position: relative;
  }
  .buttonDiv {
    bottom: 80px;
    position: fixed;
    right: 40px;
    z-index: 999;
    .el-button {
      font-size: 30px;
    }
  }
}
</style>
